import { TextField } from "@mui/material";

import { isValueless, type NumericComparator } from "../FilterSchema";

interface NumericValueInputProps {
  comparator: NumericComparator;
  value: number[];
  onChange: (next: number[]) => void;
}

export function NumericValueInput({
  comparator,
  value,
  onChange,
}: NumericValueInputProps) {
  const valueless = isValueless(comparator);

  if (valueless) {
    return null;
  }

  const text = value.length === 1 ? value[0].toString() : "";
  return (
    <TextField
      type="number"
      autoFocus
      size="small"
      fullWidth
      placeholder="Enter number..."
      value={text}
      onChange={(event) => {
        const raw = event.target.value;
        if (raw === "") {
          onChange([]);
          return;
        }
        const parsed = Number(raw);
        if (Number.isFinite(parsed)) {
          onChange([parsed]);
        }
      }}
    />
  );
}
